/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TelemetryLogRecord,
  TelemetryLogRecord$inboundSchema,
} from "./telemetrylogrecord.js";

/**
 * Result of searching telemetry logs
 */
export type SearchLogsResult = {
  /**
   * List of telemetry log records
   */
  logs: Array<TelemetryLogRecord>;
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const SearchLogsResult$inboundSchema: z.ZodMiniType<
  SearchLogsResult,
  unknown
> = z.pipe(
  z.object({
    logs: z.array(TelemetryLogRecord$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function searchLogsResultFromJSON(
  jsonString: string,
): SafeParseResult<SearchLogsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchLogsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchLogsResult' from JSON`,
  );
}
